import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  width: "24px",
  height: "24px",
  viewBox: "0 0 24 24",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  class: "svg-icon"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<g id=\"最新\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" stroke-linecap=\"round\"><g id=\"首页/点击金刚区\" transform=\"translate(-1199.000000, -693.000000)\" stroke=\"#FFFFFF\" stroke-width=\"2\"><g id=\"编组-45\" transform=\"translate(597.000000, 244.000000)\"><g id=\"编组-41\" transform=\"translate(474.000000, 439.000000)\"><g id=\"编组-44\" transform=\"translate(53.000000, 10.000000)\"><g id=\"编组-38\" transform=\"translate(75.000000, 0.000000)\"><polyline id=\"路径-3\" points=\"3 14 20.5711796 14 15.3516807 10\"></polyline></g></g></g></g></g></g>", 1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }